import { BreadcrumbJSONLD } from '~/utils/json-ld/breadcrumb';
import { useAtomValue } from 'jotai';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { $PageLevelTraffic } from 'shared/atoms';
import { FC } from 'react';
import { loadable } from 'jotai/utils';

export const JsonLD: FC = () => {
  const loadableUser = useAtomValue(loadable($CurrentAvailableUserOrNull));
  const { canonicalUrl } = useAtomValue($PageLevelTraffic);

  if (loadableUser.state !== 'hasData' || !loadableUser.data) {
    return null;
  }

  const user = loadableUser.data;

  return <BreadcrumbJSONLD nameList={['lemon8', user.nickName, 'topic']} path={canonicalUrl}></BreadcrumbJSONLD>;
};
